import { pick } from 'lodash-es'

const transformBrand = values =>
  pick(
    values,
    'id',
    'name',
    'website',
    'isHasNoWebsiteConfirmed',
    'useBrandNameAsLocationName',
  )

const transformToBrandDefinitionTaskInput = values => {
  const { task } = values
  const brandData = transformBrand(values.brand)

  return {
    id: task.id,
    brandData,
  }
}

export default transformToBrandDefinitionTaskInput
